import twLocale from "element-ui/lib/locale/lang/zh-TW";

const tw = {
  register: {
    test: "台湾",
  },
  ...twLocale,
};
export default tw;
